import OrderPlacedIcon from '../../assets/icons/OrderPlacedIcon';
import useTheme from '../../../../hooks/ui/useTheme';
import WebViewResource from '../../../../services/resources/WebViewResource';
import { AppWebViewMessageTypes } from '../../../../services/exports/Constants';
import ModalHeader from '../../components/modals/ModalHeader';
import Button from '../../components/buttons/Button';
import CustomModal from '../../../../components-library/CustomModal';
import { FC } from 'react';
import { IAlert } from '../Interfaces';
import { useTranslation } from 'react-i18next';

const RequestPushNotificationsPermitAlert: FC<IAlert> = ({ onClose, isOpen }): JSX.Element => {
  const theme = useTheme();
  const { t } = useTranslation(null, { keyPrefix: 'Modules:Mobile:Alerts:RequestPushNotificationsPermitAlert' });
  const onEnableClick = () => {
    WebViewResource.sendMessage(AppWebViewMessageTypes.RequestPushNotification, null);
    onClose();
  };

  return (
    <>
      <CustomModal open={isOpen}>
        <ModalHeader title="" onClose={onClose} />
        <div className="p-md text-center self-center">
          <OrderPlacedIcon className="h-10 mx-auto stroke-brand-primary" color={theme.color.brand.primary} />
          <h2 className="font-semibold text-md text-brand-primary mt-md">{t('title')}</h2>
          <p className="text-sm text-gray-700 mt-xs">{t('description')}</p>
          <Button onClick={onEnableClick} expand="full" title={t('buttons.enable')} className="mt-md" />
        </div>
      </CustomModal>
    </>
  );
};

export default RequestPushNotificationsPermitAlert;
